import '../locale';

class DirectoryEntryModel {

    constructor (object) {
        this._object = object;

        this.id = object.productid;
        this._map('slug', 'name', 'images', 'year', 'url', 'tags', 'texts', 'launch_year');

        this.primaryImage = this.images[0] || {small: '', medium: '', original: ''};

        this.award = {
            award: object.award,
            type: object.type,
            category: object.category,
            subcategory: object.subcategory
        };

        this.associated = this.generateCompanyInformation();

        // Determine location based on current locale (German/English)
        let isGerman = (typeof iconicLocale !== 'undefined' && iconicLocale === 'de');
        this.launch_city = isGerman ? object.launch_city_de : object.launch_city_en;
        this.launch_country = isGerman ? object.launch_country_de : object.launch_country_en;

        // Create combined location string
        this.location = [this.launch_city, this.launch_country].filter(Boolean).join(', ');

        // Fallback to client location if no launch location
        if (!this.location && this.associated.client && this.associated.client[0].city) {
            this.location = this.associated.client[0].city;
        }
    }

    _map (...keys) {
        for (let key of keys) {
            this[key] = this._object[key];
        }
    }

    generateCompanyInformation () {
        let object = this._object;

        let result = {};

        for (let company of object.associated) {
            if (!result[company.type]) result[company.type] = [];
            result[company.type].push(company);
        }

        return result;
    }

}

export default DirectoryEntryModel;
